import React from 'react'
import ReportAreasList from '../../components/reportAreas/ReportAreasList'

export default function ReportAreasManagement() {
    return (
        <ReportAreasList />
    )
}
